export const API_VERSION = 'v1';

export const USER_BASE = `/api/${API_VERSION}/User`;
export const CONTEST_MANAGEMENT_BASE = `/api/${API_VERSION}/ContestManagement`;

export const ACCESS_TOKEN = 'access_token';

// This can be string or undefined depending on .env setup
export const API_BASE_URL: string | undefined = process.env.REACT_APP_API_BASE_URL;

export const USER_DATA = 'user';

export const REGION_WISE_CONTENT_MANAGEMENT_BASE = `/api/${API_VERSION}/RegionWiseContentManagement`;

export const TRIP_MANAGEMENT_BASE = `/api/${API_VERSION}/TripManagement`;

export const CITY_BASE = `/api/${API_VERSION}/City`;

export const IMPORT_EXPORT_BASE = `/api/${API_VERSION}/ImportExport`;

export const SECTION_BASE = `/api/${API_VERSION}/Section`;

export const SUBSECTION_BASE = `/api/${API_VERSION}/SubSection`;

export const POI_BASE = `/api/${API_VERSION}/PointofInterests`;

export const ROUT_BASE = `/api/${API_VERSION}/Route`;

export const TRIPPOIs_BASE = `/api/${API_VERSION}/RoutePOIs`;

export const NOTIFICATION_BASE = `/api/${API_VERSION}/AnnouncementSupport`;

export const GEOFENCE_NOTIFICATION_BASE = `/api/${API_VERSION}/GeofenceAnnouncementSupport`;

export const MAP_BOX_ACCESS_TOKEN = 'sk.eyJ1Ijoic2hpdmFtLW52IiwiYSI6ImNtOWJoZjliMDBkanMya3F4YThlYm5kdnIifQ.2g5mumGBGXGMeBvGE0zWKg';

export const MAP_BOX_SEARCH_BASE_URL = 'https://api.mapbox.com/search/searchbox/v1/forward';

export const FAQS_BASE = `/api/${API_VERSION}/FAQ`;
